import { MIOObject } from "../MIOFoundation";



export class MIOMergePolicy extends MIOObject 
{
    
}